import { v4 as uuidv4 } from "uuid";
import { type IntlShape } from "react-intl";

import { emptyGuid } from "@/constants";
import type { SavedPackagingSolution } from "@/schemas";
import type { SavedJobCarton, SavedJobLabel, SavedJobPrint } from "@/views/production/saved-jobs/types";

export const getSolutionTemplate = (tenantId: string): SavedPackagingSolution => ({
	id: emptyGuid,
	tenantId: tenantId,
	internalUniqueId: emptyGuid,
	batchId: null,
	alias: "",
	licensePlateNumber: "",
	cartons: [],
	labels: [],
	importDate: "0001-01-01T00:00:00+00:00",
	releasedForProductionDate: "0001-01-01T00:00:00+00:00",
	cartonPropertyGroups: [],
	classification: null,
	estimatedTimeToPack: "00:00:00",
	attributes: { quantity: "1" },
	location: {},
	quantity: 1,
});

export const getCartonTemplate = (): SavedJobCarton => ({
	id: uuidv4(),
	media: {
		dimensions: {
			length: 0,
			width: 0,
			height: 0,
		},
		style: "",
		brand: "",
		thickness: 0,
		attributes: {
			name: "",
		},
	},
	attributes: {
		"@@quantity": "1",
	},
	rotation: null,
	prints: [],
	labels: [],
});

export const getPrintTemplate = (): SavedJobPrint => ({
	id: uuidv4(),
	placement: {}, //x/y coords
	media: {
		dimensions: {},
	},
	most: 0,
	value: "", //Image name
	timeToPack: "",
	attributes: {
		name: "",
		ColorWiseOff: "False",
		"@@NoValidatePrintImage": "False",
	},
});

export const getLabelTemplate = (): SavedJobLabel => ({
	id: uuidv4(),
	placement: {
		x: 0,
		y: 0,
	},
	media: {
		brand: undefined,
		style: undefined,
		dimensions: {
			width: undefined,
			length: undefined,
		},
	},
	attributes: {
		name: "",
		cartonId: "",
	},
});

export const getDefaultDisplayAlias = (intl: IntlShape, itemType: string, isPrimaryCarton = false) => {
	if (isPrimaryCarton) {
		return intl.formatMessage({ id: "primary carton", defaultMessage: "primary carton" });
	}

	return intl.formatMessage(
		{ id: `untitled_${itemType.toLowerCase()}`, defaultMessage: `untitled {itemType}` },
		{ itemType: itemType.toLowerCase() },
	);
};
